export function convertToIST(inputDateString) {
    // Parse input date string (assumes UTC time)
    const utcDate = new Date(inputDateString);
  
    // Offset IST is UTC +5:30 (in minutes: 330)
    const istOffsetMinutes = 330;
    const istDate = new Date(utcDate.getTime() + istOffsetMinutes * 60 * 1000);
  
    // Format IST date into ISO string with +05:30
    const pad = (n) => String(n).padStart(2, '0');
  
    const year = istDate.getFullYear();
    const month = pad(istDate.getMonth() + 1);
    const day = pad(istDate.getDate());
    const hours = pad(istDate.getHours());
    const minutes = pad(istDate.getMinutes());
    const seconds = pad(istDate.getSeconds());
  
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}+05:30`;
  }
  